export const TwoThreeKLessons = [
  {
    lessonNumber: 1,
    lessonTitle: "My First Day at the Company",

    PreKoreanWord1: "On my first day at the new company, I wanted to",
    KoreanWord1: "경험하다",
    KoreanWord1EngTranslation: "to experience",
    PostKoreanWord1: "something new and exciting.",

    PreKoreanWord2: "Luckily, a colleague came over and",
    KoreanWord2: "그이",
    KoreanWord2EngTranslation: "that person; he/she (old-fashioned)",
    PostKoreanWord2: "warmly welcomed me.",

    PreKoreanWord3: "The paperwork seemed to",
    KoreanWord3: "넘치다",
    KoreanWord3EngTranslation: "to overflow",
    PostKoreanWord3: "everywhere.",

    PreKoreanWord4: "I tried my best not to",
    KoreanWord4: "놓치다",
    KoreanWord4EngTranslation: "to miss",
    PostKoreanWord4: "any important instructions.",

    PreKoreanWord5:
      "A few minutes later, I had to wait in the lobby, almost like a",
    KoreanWord5: "대기",
    KoreanWord5EngTranslation: "waiting",
    PostKoreanWord5: "room before a big event.",

    PreKoreanWord6:
      "I learned that our team worked with a surprising amount of",
    KoreanWord6: "독립",
    KoreanWord6EngTranslation: "independence",
    PostKoreanWord6: "from other departments.",

    PreKoreanWord7: "While waiting, I took a moment to",
    KoreanWord7: "돌아보다",
    KoreanWord7EngTranslation: "to look back; reflect",
    PostKoreanWord7: "my past jobs.",

    PreKoreanWord8: "But before long, more tasks appeared",
    KoreanWord8: "또다시",
    KoreanWord8EngTranslation: "again; once more",
    PostKoreanWord8: "like a wave.",

    PreKoreanWord9: "My",
    KoreanWord9: "머릿속",
    KoreanWord9EngTranslation: "inside my head; mind",
    PostKoreanWord9: "was already full of so much new information.",

    PreKoreanWord10: "The company building was in the",
    KoreanWord10: "북쪽",
    KoreanWord10EngTranslation: "north",
    PostKoreanWord10: "part of the city.",

    PreKoreanWord11: "I felt a little",
    KoreanWord11: "불안하다",
    KoreanWord11EngTranslation: "to feel uneasy; anxious",
    PostKoreanWord11: "about fitting in.",

    PreKoreanWord12: "At lunch, I had a bowl of",
    KoreanWord12: "쇠고기",
    KoreanWord12EngTranslation: "beef",
    PostKoreanWord12: "soup, which helped me relax.",

    PreKoreanWord13: "The manager reminded everyone not to commit any policy",
    KoreanWord13: "위반",
    KoreanWord13EngTranslation: "violation",
    PostKoreanWord13: "during onboarding.",

    PreKoreanWord14: "One coworker came from another",
    KoreanWord14: "주",
    KoreanWord14EngTranslation: "state; province",
    PostKoreanWord14: "and told me things were different here.",

    PreKoreanWord15: "After lunch, I received a welcome",
    KoreanWord15: "카드",
    KoreanWord15EngTranslation: "card",
    PostKoreanWord15: "signed by the whole team.",

    PreKoreanWord16: "They told me this job could help me grow for my entire",
    KoreanWord16: "평생",
    KoreanWord16EngTranslation: "lifetime",
    PostKoreanWord16: "if I worked hard.",

    PreKoreanWord17:
      "Some tasks were directly related to my previous experience, so they",
    KoreanWord17: "해당하다",
    KoreanWord17EngTranslation: "to correspond; apply",
    PostKoreanWord17: "well to my skills.",

    PreKoreanWord18: "One of the senior",
    KoreanWord18: "간부",
    KoreanWord18EngTranslation: "executive; senior official",
    PostKoreanWord18: "members took the time to guide me.",

    PreKoreanWord19: "He shared useful ideas and challenged my old",
    KoreanWord19: "관념",
    KoreanWord19EngTranslation: "concept; notion",
    PostKoreanWord19: "of work.",

    PreKoreanWord20: "The first day felt",
    KoreanWord20: "굉장히",
    KoreanWord20EngTranslation: "very; extremely",
    PostKoreanWord20: "long.",

    PreKoreanWord21: "I also learnt a lot of work-related",
    KoreanWord21: "단어",
    KoreanWord21EngTranslation: "vocabulary",
    PostKoreanWord21: "that I had to remember.",

    PreKoreanWord22: "I was a bit cold so I",
    KoreanWord22: "덮다",
    KoreanWord22EngTranslation: "to cover",
    PostKoreanWord22: "myself with a blanket.",

    PreKoreanWord23: "A friendly colleague stepped in to",
    KoreanWord23: "도와주다",
    KoreanWord23EngTranslation: "to help",
    PostKoreanWord23: "with the software setup.",

    PreKoreanWord24: "He explained that the company recently decided to",
    KoreanWord24: "도입",
    KoreanWord24EngTranslation: "to introduce; adopt",
    PostKoreanWord24: "a new digital workflow.",

    PreKoreanWord25: "After work, I quickly",
    KoreanWord25: "몰다",
    KoreanWord25EngTranslation: "to drive",
    PostKoreanWord25: "home before traffic got bad.",

    PreKoreanWord26: "When I got home, I relaxed by watching my favourite",
    KoreanWord26: "배우",
    KoreanWord26EngTranslation: "actor",
    PostKoreanWord26: "on TV.",

    PreKoreanWord27: "The lamp in my room gently",
    KoreanWord27: "비추다",
    KoreanWord27EngTranslation: "to shine; illuminate",
    PostKoreanWord27: "the pages of the book I was reading.",

    PreKoreanWord28: "I changed into comfortable",
    KoreanWord28: "신발",
    KoreanWord28EngTranslation: "shoes",
    PostKoreanWord28: "to walk around the house.",

    PreKoreanWord29: "As a snack, I peeled a boiled",
    KoreanWord29: "알",
    KoreanWord29EngTranslation: "egg",
    PostKoreanWord29: "and ate it.",

    PreKoreanWord30: "I promised myself that tomorrow I would try to stay",
    KoreanWord30: "앞서다",
    KoreanWord30EngTranslation: "to stay ahead",
    PostKoreanWord30: "in my tasks instead of falling behind.",

    PreKoreanWord31: "Still, everything depends on the company’s working",
    KoreanWord31: "여건",
    KoreanWord31EngTranslation: "conditions; circumstances",
    PostKoreanWord31: "and overall environment.",

    PreKoreanWord32: "I learned this company was highly valued from",
    KoreanWord32: "오래전",
    KoreanWord32EngTranslation: "a long time ago",
    PostKoreanWord32: "and had a strong reputation.",

    PreKoreanWord33: "You really need good",
    KoreanWord33: "자격",
    KoreanWord33EngTranslation: "qualifications",
    PostKoreanWord33: "to work here.",

    PreKoreanWord34: "There are many rules to",
    KoreanWord34: "통제",
    KoreanWord34EngTranslation: "to control",
    PostKoreanWord34: "how we work.",

    PreKoreanWord35: "During the break, I climbed the",
    KoreanWord35: "계단",
    KoreanWord35EngTranslation: "stairs",
    PostKoreanWord35: "for some exercise.",

    PreKoreanWord36: "At dinner, I ate some spicy",
    KoreanWord36: "김치",
    KoreanWord36EngTranslation: "kimchi",
    PostKoreanWord36: "for the health benefits.",

    PreKoreanWord37: "If I'm happy with what I hear I",
    KoreanWord37: "끄덕이다",
    KoreanWord37EngTranslation: "to nod",
    PostKoreanWord37: "in agreement.",

    PreKoreanWord38: "Even if things feel a bit",
    KoreanWord38: "낯설다",
    KoreanWord38EngTranslation: "to feel unfamiliar",
    PostKoreanWord38: "I can adjust.",

    PreKoreanWord39: "The new office building has a lot of",
    KoreanWord39: "높이",
    KoreanWord39EngTranslation: "height",
    PostKoreanWord39: "when viewed from outside.",

    PreKoreanWord40: "Someone joked that I",
    KoreanWord40: "닮다",
    KoreanWord40EngTranslation: "to resemble",
    PostKoreanWord40: "the CEO a little, which made everyone laugh.",

    PreKoreanWord41: "That comment stayed in my",
    KoreanWord41: "마음속",
    KoreanWord41EngTranslation: "heart; mind",
    PostKoreanWord41: "longer than expected.",

    PreKoreanWord42: "I soon learned that my new team was",
    KoreanWord42: "못지않다",
    KoreanWord42EngTranslation: "to be just as good as",
    PostKoreanWord42: "people in any other company.",

    PreKoreanWord43: "The office culture clearly",
    KoreanWord43: "반영하다",
    KoreanWord43EngTranslation: "to reflect",
    PostKoreanWord43: "the values of the leadership.",

    PreKoreanWord44: "While eating, I had to be careful not to swallow a small",
    KoreanWord44: "뼈",
    KoreanWord44EngTranslation: "bone",
    PostKoreanWord44: "from the fish.",

    PreKoreanWord45: "After a full day, I felt I was slowly beginning to",
    KoreanWord45: "성장하다",
    KoreanWord45EngTranslation: "to grow",
    PostKoreanWord45: "in my new role.",

    PreKoreanWord46: "I finally felt like I was truly",
    KoreanWord46: "소속",
    KoreanWord46EngTranslation: "belonging; affiliation",
    PostKoreanWord46: "to the company.",

    PreKoreanWord47: "Over time, I wanted to",
    KoreanWord47: "연결되다",
    KoreanWord47EngTranslation: "to become connected",
    PostKoreanWord47: "more with my team.",

    PreKoreanWord48: "On the way home, I saw local businesses doing",
    KoreanWord48: "장사",
    KoreanWord48EngTranslation: "business; trade",
    PostKoreanWord48: "on the street.",

    PreKoreanWord49: "At night, I",
    KoreanWord49: "제작",
    KoreanWord49EngTranslation: "to produce; make",
    PostKoreanWord49: "a short video about my day.",

    PreKoreanWord50: "But eventually, my energy hit the",
    KoreanWord50: "제한",
    KoreanWord50EngTranslation: "limit",
    PostKoreanWord50: "and I had to go to sleep.",
  },
  {
    lessonNumber: 2,
    lessonTitle: "A Busy Morning in a Small Café",

    PreKoreanWord1: "The café was already",
    KoreanWord1: "차다",
    KoreanWord1EngTranslation: "to be full",
    PostKoreanWord1: "when I arrived in the morning.",

    PreKoreanWord2: "The owner was busy",
    KoreanWord2: "추진",
    KoreanWord2EngTranslation: "promoting; pushing forward",
    PostKoreanWord2: "a new menu idea.",

    PreKoreanWord3: "I felt tired, so I decided to",
    KoreanWord3: "취하다",
    KoreanWord3EngTranslation: "to take; to rest",
    PostKoreanWord3: "a short rest before ordering.",

    PreKoreanWord4: "The smell of boiling",
    KoreanWord4: "콩",
    KoreanWord4EngTranslation: "beans",
    PostKoreanWord4: "soup filled the air.",

    PreKoreanWord5: "A student next to me let out a long",
    KoreanWord5: "한숨",
    KoreanWord5EngTranslation: "sigh",
    PostKoreanWord5: "while studying.",

    PreKoreanWord6: "She said she had just",
    KoreanWord6: "헤어지다",
    KoreanWord6EngTranslation: "to break up",
    PostKoreanWord6: "with her boyfriend.",

    PreKoreanWord7: "To cheer herself up, she decided to",
    KoreanWord7: "구입하다",
    KoreanWord7EngTranslation: "to purchase",
    PostKoreanWord7: "a sweet drink.",

    PreKoreanWord8: "A bird tried to",
    KoreanWord8: "날다",
    KoreanWord8EngTranslation: "to fly",
    PostKoreanWord8: "inside through the open window.",

    PreKoreanWord9: "It landed gently on a chair",
    KoreanWord9: "너머",
    KoreanWord9EngTranslation: "beyond; on the other side of",
    PostKoreanWord9: "from me.",

    PreKoreanWord10: "The barista asked about my",
    KoreanWord10: "동기",
    KoreanWord10EngTranslation: "motivation",
    PostKoreanWord10: "for coming so early.",

    PreKoreanWord11: "I said I needed time to",
    KoreanWord11: "마련",
    KoreanWord11EngTranslation: "preparation; arrangement",
    PostKoreanWord11: "some personal things for later.",

    PreKoreanWord12: "Another customer told me he was 20",
    KoreanWord12: "살",
    KoreanWord12EngTranslation: "years old",
    PostKoreanWord12: "today.",

    PreKoreanWord13: "His dream was to become the",
    KoreanWord13: "선장",
    KoreanWord13EngTranslation: "ship captain",
    PostKoreanWord13: "of a ship.",

    PreKoreanWord14: "He added extra",
    KoreanWord14: "설탕",
    KoreanWord14EngTranslation: "sugar",
    PostKoreanWord14: "to his coffee.",

    PreKoreanWord15: "His smile was so",
    KoreanWord15: "순수하다",
    KoreanWord15EngTranslation: "pure",
    PostKoreanWord15: "it made everyone around him relax.",

    PreKoreanWord16: "His hair had a cool",
    KoreanWord16: "스타일",
    KoreanWord16EngTranslation: "style",
    PostKoreanWord16: "that caught people’s attention.",

    PreKoreanWord17: "Now is the perfect",
    KoreanWord17: "시점",
    KoreanWord17EngTranslation: "point in time",
    PostKoreanWord17: "to order an early lunch.",

    PreKoreanWord18: "The sandwich was surprisingly",
    KoreanWord18: "싸다",
    KoreanWord18EngTranslation: "cheap",
    PostKoreanWord18: "for its size.",

    PreKoreanWord19: "Then in walked the",
    KoreanWord19: "의사",
    KoreanWord19EngTranslation: "doctor",
    PostKoreanWord19: "to get some coffee to drink.",

    PreKoreanWord20: "I tried to",
    KoreanWord20: "집중",
    KoreanWord20EngTranslation: "concentrate",
    PostKoreanWord20: "on my book.",

    PreKoreanWord21: "I scanned the QR",
    KoreanWord21: "코드",
    KoreanWord21EngTranslation: "code",
    PostKoreanWord21: "on my phone screen.",

    PreKoreanWord22: "Suddenly, the barista shouted that a",
    KoreanWord22: "큰일",
    KoreanWord22EngTranslation: "big problem; serious matter",
    PostKoreanWord22: "had happened.",

    PreKoreanWord23: "Someone had been telling",
    KoreanWord23: "거짓말",
    KoreanWord23EngTranslation: "lies",
    PostKoreanWord23: "about finishing his work.",

    PreKoreanWord24: "Really not an",
    KoreanWord24: "대단하다",
    KoreanWord24EngTranslation: "great; impressive",
    PostKoreanWord24: "situation to be in.",

    PreKoreanWord25: "One person laughed",
    KoreanWord25: "대단히",
    KoreanWord25EngTranslation: "greatly; very much",
    PostKoreanWord25: "loudly.",

    PreKoreanWord26: "I noticed two friends sitting",
    KoreanWord26: "마주",
    KoreanWord26EngTranslation: "facing; opposite",
    PostKoreanWord26: "each other.",

    PreKoreanWord27: "They discussed their different",
    KoreanWord27: "세계관",
    KoreanWord27EngTranslation: "worldview",
    PostKoreanWord27: "over coffee.",

    PreKoreanWord28: "They talked about what happened",
    KoreanWord28: "어제",
    KoreanWord28EngTranslation: "yesterday",
    PostKoreanWord28: "at work.",

    PreKoreanWord29: "The café was",
    KoreanWord29: "온통",
    KoreanWord29EngTranslation: "completely; entirely",
    PostKoreanWord29: "filled with the smell of cinnamon.",

    PreKoreanWord30: "One girl said she was",
    KoreanWord30: "의존하다",
    KoreanWord30EngTranslation: "to depend on",
    PostKoreanWord30: "energy drinks.",

    PreKoreanWord31: "The barista tried to explain the tea",
    KoreanWord31: "자세히",
    KoreanWord31EngTranslation: "in detail",
    PostKoreanWord31: "to her.",

    PreKoreanWord32: "Most customers ordered",
    KoreanWord32: "점심",
    KoreanWord32EngTranslation: "lunch",
    PostKoreanWord32: "early too.",

    PreKoreanWord33: "The chef measured spices",
    KoreanWord33: "정확히",
    KoreanWord33EngTranslation: "exactly; precisely",
    PostKoreanWord33: "then made the dish.",

    PreKoreanWord34: "A stressed man said he was already",
    KoreanWord34: "지치다",
    KoreanWord34EngTranslation: "tired; exhausted",
    PostKoreanWord34: "from morning meetings.",

    PreKoreanWord35: "While a",
    KoreanWord35: "청년",
    KoreanWord35EngTranslation: "young man",
    PostKoreanWord35: "at the next table practiced a speech.",

    PreKoreanWord36: "He kept sticking out his",
    KoreanWord36: "혀",
    KoreanWord36EngTranslation: "tongue",
    PostKoreanWord36: "while thinking.",

    PreKoreanWord37: "The café owner intends to",
    KoreanWord37: "확대하다",
    KoreanWord37EngTranslation: "to expand",
    PostKoreanWord37: "the store.",

    PreKoreanWord38: "My sandwich was good but needed some",
    KoreanWord38: "후춧가루",
    KoreanWord38EngTranslation: "black pepper",
    PostKoreanWord38: "to make it complete.",

    PreKoreanWord39: "They might need to",
    KoreanWord39: "건설하다",
    KoreanWord39EngTranslation: "to construct; build",
    PostKoreanWord39: "a new building.",

    PreKoreanWord40: "The café had strong",
    KoreanWord40: "경쟁력",
    KoreanWord40EngTranslation: "competitiveness",
    PostKoreanWord40: "so they can afford it.",

    PreKoreanWord41: "Then,",
    KoreanWord41: "마침",
    KoreanWord41EngTranslation: "just then",
    PostKoreanWord41: "my drink was finally ready.",

    PreKoreanWord42: "I paid with my",
    KoreanWord42: "신용",
    KoreanWord42EngTranslation: "credit",
    PostKoreanWord42: "card.",

    PreKoreanWord43: "I told the barista I would",
    KoreanWord43: "연락",
    KoreanWord43EngTranslation: "contact",
    PostKoreanWord43: "her later.",

    PreKoreanWord44: "A nice feeling spread through my",
    KoreanWord44: "온몸",
    KoreanWord44EngTranslation: "whole body",
    PostKoreanWord44: "and made me feel alive.",

    PreKoreanWord45: "I felt a sense of",
    KoreanWord45: "정",
    KoreanWord45EngTranslation: "affection; warmth",
    PostKoreanWord45: "toward the cozy café.",

    PreKoreanWord46: "My stress disappeared and I felt",
    KoreanWord46: "정신적",
    KoreanWord46EngTranslation: "mental",
    PostKoreanWord46: "lighter and happier.",

    PreKoreanWord47: "I had some",
    KoreanWord47: "증상",
    KoreanWord47EngTranslation: "symptoms",
    PostKoreanWord47: "of the flu, but I'm hoping it's nothing.",

    PreKoreanWord48: "An actor who is soon to",
    KoreanWord48: "출연하다",
    KoreanWord48EngTranslation: "to appear (on TV)",
    PostKoreanWord48: "was there too.",

    PreKoreanWord49: "He used a sharp",
    KoreanWord49: "칼",
    KoreanWord49EngTranslation: "knife",
    PostKoreanWord49: "to cut his cake.",

    PreKoreanWord50: "Suddenly, many customers stood up",
    KoreanWord50: "한꺼번에",
    KoreanWord50EngTranslation: "all at once",
    PostKoreanWord50: "to leave for lunch meetings.",
  },
  {
    lessonNumber: 3,
    lessonTitle: "Visiting a University Campus New",

    PreKoreanWord1: "I don't need to be",
    KoreanWord1: "강제",
    KoreanWord1EngTranslation: "force; coercion",
    PostKoreanWord1: "to go, I wanted to.",

    PreKoreanWord2: "To get there, I had to",
    KoreanWord2: "건너다",
    KoreanWord2EngTranslation: "to cross",
    PostKoreanWord2: "a bridge just outside the city.",

    PreKoreanWord3: "It wasn't hard to",
    KoreanWord3: "깨다",
    KoreanWord3EngTranslation: "to wake up; snap out",
    PostKoreanWord3: "from my sleepy mood.",

    PreKoreanWord4: "On the way, I passed a lake where people were",
    KoreanWord4: "낚시",
    KoreanWord4EngTranslation: "fishing",
    PostKoreanWord4: "for lunch.",

    PreKoreanWord5: "As I",
    KoreanWord5: "다가가다",
    KoreanWord5EngTranslation: "to approach",
    PostKoreanWord5: "the campus gate, I felt excited.",

    PreKoreanWord6: "A group of students suddenly",
    KoreanWord6: "뛰어들다",
    KoreanWord6EngTranslation: "to jump/run into",
    PostKoreanWord6: "into the building to avoid the rain.",

    PreKoreanWord7: "My phone buzzed with a",
    KoreanWord7: "문자",
    KoreanWord7EngTranslation: "text message",
    PostKoreanWord7: "from a friend asking how the visit was going.",

    PreKoreanWord8: "I went over to the staff to",
    KoreanWord8: "묻다",
    KoreanWord8EngTranslation: "to ask",
    PostKoreanWord8: "about the tour schedule.",

    PreKoreanWord9: "She said this university",
    KoreanWord9: "비롯되다",
    KoreanWord9EngTranslation: "to originate; start",
    PostKoreanWord9: "from a small private school long ago.",

    PreKoreanWord10: "The campus looked beautiful but",
    KoreanWord10: "슬프다",
    KoreanWord10EngTranslation: "sad",
    PostKoreanWord10: "because it was so quiet.",

    PreKoreanWord11: "At the chapel, a couple were taking photos with the",
    KoreanWord11: "신부",
    KoreanWord11EngTranslation: "bride",
    PostKoreanWord11: "smiling beautifully.",

    PreKoreanWord12: "This university is often",
    KoreanWord12: "여겨지다",
    KoreanWord12EngTranslation: "to be considered",
    PostKoreanWord12: "as the best in the region.",

    PreKoreanWord13: "At the cafeteria, the smell of grilled",
    KoreanWord13: "오징어",
    KoreanWord13EngTranslation: "squid",
    PostKoreanWord13: "was everywhere.",

    PreKoreanWord14: "I paid the entrance",
    KoreanWord14: "요금",
    KoreanWord14EngTranslation: "fee",
    PostKoreanWord14: "and continued walking.",

    PreKoreanWord15: "The students here don't get much",
    KoreanWord15: "용돈",
    KoreanWord15EngTranslation: "allowance",
    PostKoreanWord15: "so have to eat cheap lunches.",

    PreKoreanWord16: "The library tour was",
    KoreanWord16: "위주",
    KoreanWord16EngTranslation: "focused on",
    PostKoreanWord16: "the history of the school.",

    PreKoreanWord17: "I bought a cold",
    KoreanWord17: "음료",
    KoreanWord17EngTranslation: "drink",
    PostKoreanWord17: "before exploring the main building.",

    PreKoreanWord18: "There were many old items and one wooden",
    KoreanWord18: "의자",
    KoreanWord18EngTranslation: "chair",
    PostKoreanWord18: "looked really old.",

    PreKoreanWord19: "The engineering center had a whole section about",
    KoreanWord19: "전자",
    KoreanWord19EngTranslation: "electronics",
    PostKoreanWord19: "technology.",

    PreKoreanWord20: "These inventions were then",
    KoreanWord20: "전해지다",
    KoreanWord20EngTranslation: "to be transmitted; spread",
    PostKoreanWord20: "around the world.",

    PreKoreanWord21: "The teachers were talking about a big",
    KoreanWord21: "전환",
    KoreanWord21EngTranslation: "transition; change",
    PostKoreanWord21: "in the school’s teaching style.",

    PreKoreanWord22: "One lab room was in such a strange",
    KoreanWord22: "지경",
    KoreanWord22EngTranslation: "state; condition",
    PostKoreanWord22: "that we were not allowed to enter.",

    PreKoreanWord23: "In another room, a research project was still in",
    KoreanWord23: "진행",
    KoreanWord23EngTranslation: "progress",
    PostKoreanWord23: ".",

    PreKoreanWord24: "Many visitors carried a",
    KoreanWord24: "카메라",
    KoreanWord24EngTranslation: "camera",
    PostKoreanWord24: "and took photos.",

    PreKoreanWord25: "One person complained about knee",
    KoreanWord25: "통증",
    KoreanWord25EngTranslation: "pain",
    PostKoreanWord25: "after walking so much.",

    PreKoreanWord26: "The campus map made it really",
    KoreanWord26: "편리하다",
    KoreanWord26EngTranslation: "convenient",
    PostKoreanWord26: "to find each building.",

    PreKoreanWord27: "A beautiful",
    KoreanWord27: "하천",
    KoreanWord27EngTranslation: "stream",
    PostKoreanWord27: "ran beside the science hall.",

    PreKoreanWord28: "At the market you could only pay by",
    KoreanWord28: "현금",
    KoreanWord28EngTranslation: "cash",
    PostKoreanWord28: "and not by card.",

    PreKoreanWord29: "The largest department focused on",
    KoreanWord29: "화학",
    KoreanWord29EngTranslation: "chemistry",
    PostKoreanWord29: "experiments.",

    PreKoreanWord30: "The students there were very",
    KoreanWord30: "활발하다",
    KoreanWord30EngTranslation: "active; lively",
    PostKoreanWord30: "and fun.",

    PreKoreanWord31: "One research machine had a piece to",
    KoreanWord31: "가리다",
    KoreanWord31EngTranslation: "to cover; shield",
    PostKoreanWord31: "the light.",

    PreKoreanWord32: "I heard some people talking in a",
    KoreanWord32: "거칠다",
    KoreanWord32EngTranslation: "rough; harsh",
    PostKoreanWord32: "way.",

    PreKoreanWord33: "That was bad",
    KoreanWord33: "그나마",
    KoreanWord33EngTranslation: "at least",
    PostKoreanWord33: "it didn't get any worse.",

    PreKoreanWord34: "The main gate was",
    KoreanWord34: "그야말로",
    KoreanWord34EngTranslation: "truly; literally",
    PostKoreanWord34: "the symbol of the university.",

    PreKoreanWord35: "A student peeled an orange and threw the",
    KoreanWord35: "껍질",
    KoreanWord35EngTranslation: "peel",
    PostKoreanWord35: "into the bin.",

    PreKoreanWord36: "The tour continued toward the",
    KoreanWord36: "남부",
    KoreanWord36EngTranslation: "southern",
    PostKoreanWord36: "part of the campus.",

    PreKoreanWord37: "In one classroom, a professor shouted",
    KoreanWord37: "명령",
    KoreanWord37EngTranslation: "command",
    PostKoreanWord37: "to a sleepy class.",

    PreKoreanWord38: "A student was eating snacks",
    KoreanWord38: "몰래",
    KoreanWord38EngTranslation: "secretly",
    PostKoreanWord38: "behind her textbook.",

    PreKoreanWord39: "The guide said the school cafeteria was",
    KoreanWord39: "무조건",
    KoreanWord39EngTranslation: "unconditionally",
    PostKoreanWord39: "cheap for all students.",

    PreKoreanWord40: "We met the class",
    KoreanWord40: "반장",
    KoreanWord40EngTranslation: "class president",
    PostKoreanWord40: "who told us about his role.",

    PreKoreanWord41: "A small café was located in the",
    KoreanWord41: "부근",
    KoreanWord41EngTranslation: "vicinity",
    PostKoreanWord41: "of the library.",

    PreKoreanWord42: "Students could",
    KoreanWord42: "선택",
    KoreanWord42EngTranslation: "to choose",
    PostKoreanWord42: "courses that interested them.",

    PreKoreanWord43: "One professor was a famous",
    KoreanWord43: "역사가",
    KoreanWord43EngTranslation: "historian",
    PostKoreanWord43: ".",

    PreKoreanWord44: "We also met a biology",
    KoreanWord44: "연구자",
    KoreanWord44EngTranslation: "researcher",
    PostKoreanWord44: "who studied rare insects.",

    PreKoreanWord45: "Later, an",
    KoreanWord45: "연기자",
    KoreanWord45EngTranslation: "actor; performer",
    PostKoreanWord45: "gave us a show on the outdoor stage.",

    PreKoreanWord46: "The tour was long, but the campus was",
    KoreanWord46: "워낙",
    KoreanWord46EngTranslation: "so; extremely",
    PostKoreanWord46: "beautiful so it didn’t bother me.",

    PreKoreanWord47: "Before leaving, I did a brief",
    KoreanWord47: "정리",
    KoreanWord47EngTranslation: "organizing; sorting",
    PostKoreanWord47: "of the photos on my phone.",

    PreKoreanWord48: "There were so many",
    KoreanWord48: "조그맣다",
    KoreanWord48EngTranslation: "tiny; small",
    PostKoreanWord48: "details to take note of.",

    PreKoreanWord49: "The trees had long, colorful",
    KoreanWord49: "줄기",
    KoreanWord49EngTranslation: "stems",
    PostKoreanWord49: "hanging down.",

    PreKoreanWord50: "I walked around one more time to",
    KoreanWord50: "찾아내다",
    KoreanWord50EngTranslation: "to find out; discover",
    PostKoreanWord50: "a hidden garden behind the library.",
  },
];
